import isEqual from 'lodash/isEqual';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { Navigation } from './Navigation'; 
import { Courses } from './components/Courses';
import { Primary } from './components/Primary';
import { Footer } from './components/Footer';
import LocationProgress from './shared/LocationProgress';
import { About } from './components/About';
import { CourseDetail } from './components/CourseDetail';
import { CourseContext } from "./components/CourseContext";
import './style.css';
import { Themes } from "./components/Themes";
import { Lesson } from "./components/Lesson";
import { Test } from "./components/Test";
import { Login } from "./components/login/Login";
import { Register } from "./components/register/Register";
import { Profile } from "./components/Profile";
import { MoreUser } from "./components/moreUser";
import { Yakuniy } from "./components/Yakuniy";
import { CourseComment } from "./components/CourseComment";

import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './components/Dashboard';
import { AuthProvider, useAuth } from './context/AuthContext';
import i18n from './i18n';
import { ScrollToTop } from './ScrollToTop';
import { TranslationProvider } from "./components/TranslationContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const courses1 = []

  export const Layout = () => {
    // const { language } = useAuth();

  // useEffect(() => {
  //   i18n.changeLanguage(language);
  // }, [language]);

    const [data, setData] = useState([]);        // состояние для хранения данных
    const [loading, setLoading] = useState(true);  // индикатор загрузки
    const [error, setError] = useState(null);      // состояние ошибки

    useEffect(() => {
        fetch("https://api.rasulova-academy.uz/api/kurslar/")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Ошибка сети: " + response.status);
            }
            return response.json();  // преобразование в JSON
          })
          .then((json) => {
            setData(json);           // сохранение данных
            setLoading(false);
          })
          .catch((err) => {
            setError(err.message);   // обработка ошибок
            setLoading(false);
          });
      }, []);
      // let dataList = JSON.stringify(data, null, 2)
      // console.log(dataList)
      // data.forEach(function(entry) {
      //   console.log(entry);
      // });
       data.map(user => {
         let objData = {
            id: user.id,
            author: user.user,
            title_uz: user.nomi_uz,
            title_ru: user.nomi_ru,
            title_en: user.nomi_en,
            duration: user.davomiyligi,
            desc_uz: user.description_uz,
            desc_ru: user.description_ru,
            desc_en: user.description_en,
            img_uz: user.img_uz,
            img_ru: user.img_ru,
            img_en: user.img_en,
            img1_uz: user.img1_uz,
            img1_ru: user.img1_ru,
            img1_en: user.img1_en
         }
         if (!courses1.some(item => isEqual(item, objData))) {
          courses1.push(objData)
         }

        })
      
    return (
      <>
      <ToastContainer position="top-right" autoClose={3000} />
      <TranslationProvider>
      <ScrollToTop />
      <AuthProvider>
      <CourseContext.Provider value={courses1}>
        <div className="main">
          <Navigation />
          <LocationProgress />
          
            <Routes>
                <Route path="/" element={<Primary />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/about" element={<About />} />
                <Route path="/course/:id" element={<CourseDetail />} />
                <Route path="/themes/:id" element={<Themes />} />
                <Route path="/courseComment/:id" element={<CourseComment />} />
                <Route path="/lesson/:kursId/:id" element={<Lesson />} />
                <Route path="/test/:kursId/:id/:themes/:nextLessonId" element={<Test />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/more" element={<MoreUser />} />
                <Route path="/yakuniy/:kursId" element={<Yakuniy />} />

                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
            </Routes>
          
  
          <Footer />
        </div>
      </CourseContext.Provider>
      </AuthProvider>
      </TranslationProvider>
      </>
    );
  };
